/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Deep_P1Inputs */

const en_to_typescript_deep_p1 = /** @type {(inputs: To_Typescript_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionality is inferred only from arrays. If you paste an array of objects and a key is missing from some elements, that key is marked optional with a question mark. If you paste a single object, every key it has is required and every key it lacks does not exist, because a single sample offers no evidence either way. This is why an array of two or three representative records produces much better types than one object.`)
};

const ko_to_typescript_deep_p1 = /** @type {(inputs: To_Typescript_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택성은 배열에서만 추론됩니다. 객체 배열을 붙여넣었을 때 일부 요소에 키가 없으면 그 키는 물음표로 선택적임이 표시됩니다. 단일 객체를 붙여넣으면 가진 키는 모두 필수이고 없는 키는 존재하지 않게 됩니다. 단일 샘플은 어느 쪽으로도 근거를 주지 않기 때문입니다. 대표적인 레코드 두세 개로 된 배열이 객체 하나보다 훨씬 나은 타입을 만드는 이유입니다.`)
};

const ja_to_typescript_deep_p1 = /** @type {(inputs: To_Typescript_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意性は配列からのみ推論されます。オブジェクトの配列を貼り付けて、一部の要素にキーがなければ、そのキーは疑問符付きで任意と示されます。単一のオブジェクトを貼り付けると、持っているキーはすべて必須で、持っていないキーは存在しないことになります。単一サンプルはどちらの根拠も与えないからです。代表的なレコードが 2 つか 3 つ入った配列が、オブジェクト 1 つよりずっと良い型を生む理由です。`)
};

/**
* | output |
* | --- |
* | "Optionality is inferred only from arrays. If you paste an array of objects and a key is missing from some elements, that key is marked optional with a questi..." |
*
* @param {To_Typescript_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_deep_p1 = /** @type {((inputs?: To_Typescript_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_deep_p1(inputs)
	if (locale === "ko") return ko_to_typescript_deep_p1(inputs)
	return ja_to_typescript_deep_p1(inputs)
});